import axios from "axios";
import url1 from '../../config.js'
const url=`${url1.url}/api/lessonquestionmapping`;

export default class LessonQuestionMapping {
    constructor(){//lessonquestionmapping = {}) {
        // this.lesson_id = lessonquestionmapping.lesson_id || "";
        // this.question_id=lessonquestionmapping.question_id||"";
        // this.questionOrder=lessonquestionmapping.questionOrder||0,
        // this.questionStatus=lessonquestionmapping.questionStatus||true
    }

        //to get existing questions for ModifyQuestionsInALesson page
        static getExistingQuestionsOfALesson=async (lesson_id, token)=>{
            return axios.get(`${url}/questionsofalesson/${lesson_id}`, {headers:{"x-auth-token":token}})
        }

        static getRemainingQuestionsOfALesson=async(lesson_id, token)=>{
            return axios.get(`${url}/remainingquestionsofalesson/${lesson_id}`, {headers:{"x-auth-token":token}})
        }
   
    //save questions to a lesson on modifyquestionsinalesson.vue
        static putQuestionsToLesson(lesson_id, lessonQuestionList, token) {//(token)
            console.log('put questions to lesson model client',lesson_id, lessonQuestionList);
            return axios.put(`${url}/savequestionstoalesson/${lesson_id}`, lessonQuestionList, {headers:{"x-auth-token":token}});
        }


        static deleteLesson(lesson_id, token) {
            return (
                confirm("Are you sure you want to delete this lesson?") &&
                axios.delete(`${url}/lesson/${lesson_id}`, {headers:{"x-auth-token":token}})
            )
    
        }
        static putQuestionStatusByLesson(lesson_id, question_id, questionStatus, token) {
            //console.log('put admin user client',adminUserEmail,adminuser)
            return axios.put(`${url}/changequestionstatusbylesson/${lesson_id}/${question_id}`, {questionStatus:questionStatus}, {headers:{"x-auth-token":token}});
        }

        static putQuestionStatusonMasterStatusChange(question_id, questionStatus, questionType, token) {
            //console.log('put admin user client',adminUserEmail,adminuser)
            console.log('put question type one', questionType);
            return axios.put(`${url}/changequestionstatusbymasterquestionstatus/${question_id}`, {questionStatus:questionStatus, questionType:questionType}, {headers:{"x-auth-token":token}});
        }

        static deleteQuestion(question_id, questionType, token) {
            console.log('delete model', token, 'question type', questionType, typeof questionType);
            return (
                confirm("Are you sure you want to delete this question?") &&
                axios.delete(`${url}/question/${question_id}/${questionType}`, {headers:{"x-auth-token":token}})
            )
    
        }
}